import i18n from '../../i18n/i18n';
import { lightenHex } from './Utils';

export const formatFilterQuery = (query) => {
  const columnField = query?.get("columnField");
  const operatorValue = query?.get("operatorValue");
  const value = query?.get("value");

  let items = [];
  if (columnField && operatorValue && value && value !== "all") {
    items = [{ columnField, operatorValue, value }];
  }
  return {items};
};

export const sheetStyle = {
  "& .MuiDataGrid-main": {
    borderRadius: "0",
    boxShadow: "none",
  },
  "& .MuiDataGrid-columnHeadersInner": {
    background: "#F2F3F7",
    color: "#9A9AAF",
    fontSize: "12px",
    borderRadius: "0 !important",
  },
}

export const dataGridTranslation = () => {
  return {
    // --- Filtres toolBar Mui
    noRowsLabel: i18n.t("dataGrid.noRowsLabel"),
    noResultsOverlayLabel: i18n.t("dataGrid.noResultsOverlayLabel"),
    // Colonnes
    toolbarColumns: '',
    columnsPanelTextFieldLabel: i18n.t("dataGrid.columnsPanelTextFieldLabel"),
    toolbarColumnsLabel: i18n.t("dataGrid.toolbarColumnsLabel"),
    columnsPanelTextFieldPlaceholder: i18n.t("dataGrid.columnsPanelTextFieldPlaceholder"),
    columnsPanelShowAllButton: i18n.t("dataGrid.columnsPanelShowAllButton"),
    columnsPanelHideAllButton: i18n.t("dataGrid.columnsPanelHideAllButton"),
    // Densité
    toolbarDensity: '',
    toolbarDensityLabel: i18n.t("dataGrid.toolbarDensityLabel"),
    toolbarDensityCompact: i18n.t("dataGrid.toolbarDensityCompact"),
    toolbarDensityStandard: i18n.t("dataGrid.toolbarDensityStandard"),
    toolbarDensityComfortable: i18n.t("dataGrid.toolbarDensityComfortable"),
    // Filtres
    toolbarFilters: i18n.t("dataGrid.toolbarFilters"),
    toolbarFiltersLabel: i18n.t("dataGrid.toolbarFiltersLabel"),
    toolbarFiltersTooltipHide: i18n.t("dataGrid.toolbarFiltersTooltipHide"),
    toolbarFiltersTooltipShow: i18n.t("dataGrid.toolbarFiltersTooltipShow"),
    // Export
    toolbarExport: i18n.t("tableLabels.toolbar.export"),
    toolbarExportCSV: i18n.t("tableLabels.toolbar.exportCsv"),
    toolbarExportExcel: i18n.t("tableLabels.toolbar.exportExcelXlsx"),
    toolbarExportPrint: i18n.t("tableLabels.toolbar.print"),
    // Filter operators text
    filterPanelAddFilter: i18n.t('dataGrid.filterPanelAddFilter'),
    filterPanelRemoveAll: i18n.t('dataGrid.filterPanelRemoveAll'),
    filterPanelDeleteIconLabel: i18n.t('dataGrid.filterPanelDeleteIconLabel'),
    filterPanelLogicOperator: i18n.t('dataGrid.filterPanelLogicOperator'),
    filterPanelOperator: i18n.t('dataGrid.filterPanelOperator'),
    filterPanelOperatorAnd: i18n.t('dataGrid.filterPanelOperatorAnd'),
    filterPanelOperatorOr: i18n.t('dataGrid.filterPanelOperatorOr'),
    filterPanelColumns: i18n.t('dataGrid.filterPanelColumns'),
    filterPanelInputLabel: i18n.t('dataGrid.filterPanelInputLabel'),
    filterPanelInputPlaceholder: i18n.t('dataGrid.filterPanelInputPlaceholder'),
    filterOperatorContains: i18n.t('dataGrid.filterOperatorContains'),
    filterOperatorDoesNotContain: i18n.t('dataGrid.filterOperatorDoesNotContain'),
    filterOperatorEquals: i18n.t('dataGrid.filterOperatorEquals'),
    filterOperatorDoesNotEqual: i18n.t('dataGrid.filterOperatorDoesNotEqual'),
    filterOperatorStartsWith: i18n.t('dataGrid.filterOperatorStartsWith'),
    filterOperatorEndsWith: i18n.t('dataGrid.filterOperatorEndsWith'),
    filterOperatorIs: i18n.t('dataGrid.filterOperatorIs'),
    filterOperatorNot: i18n.t('dataGrid.filterOperatorNot'),
    filterOperatorAfter: i18n.t('dataGrid.filterOperatorAfter'),
    filterOperatorOnOrAfter: i18n.t('dataGrid.filterOperatorOnOrAfter'),
    filterOperatorBefore: i18n.t('dataGrid.filterOperatorBefore'),
    filterOperatorOnOrBefore: i18n.t('dataGrid.filterOperatorOnOrBefore'),
    filterOperatorIsEmpty: i18n.t('dataGrid.filterOperatorIsEmpty'),
    filterOperatorIsNotEmpty: i18n.t('dataGrid.filterOperatorIsNotEmpty'),
    filterOperatorIsAnyOf: i18n.t('dataGrid.filterOperatorIsAnyOf'),
    'filterOperator=': i18n.t('dataGrid.filterOperatorEqual'),
    'filterOperator!=': i18n.t('dataGrid.filterOperatorNotEqual'),
    'filterOperator>': i18n.t('dataGrid.filterOperatorGreaterThan'),
    'filterOperator>=': i18n.t('dataGrid.filterOperatorGreaterThanOrEqual'),
    'filterOperator<': i18n.t('dataGrid.filterOperatorLessThan'),
    'filterOperator<=': i18n.t('dataGrid.filterOperatorLessThanOrEqual'),
    headerFilterOperatorContains: i18n.t('dataGrid.headerFilterOperatorContains'),
    headerFilterOperatorDoesNotContain: i18n.t('dataGrid.headerFilterOperatorDoesNotContain'),
    headerFilterOperatorEquals: i18n.t('dataGrid.headerFilterOperatorEquals'),
    headerFilterOperatorDoesNotEqual: i18n.t('dataGrid.headerFilterOperatorDoesNotEqual'),
    headerFilterOperatorStartsWith: i18n.t('dataGrid.headerFilterOperatorStartsWith'),
    headerFilterOperatorEndsWith: i18n.t('dataGrid.headerFilterOperatorEndsWith'),
    headerFilterOperatorIs: i18n.t('dataGrid.headerFilterOperatorIs'),
    headerFilterOperatorNot: i18n.t('dataGrid.headerFilterOperatorNot'),
    headerFilterOperatorAfter: i18n.t('dataGrid.headerFilterOperatorAfter'),
    headerFilterOperatorOnOrAfter: i18n.t('dataGrid.headerFilterOperatorOnOrAfter'),
    headerFilterOperatorBefore: i18n.t('dataGrid.headerFilterOperatorBefore'),
    headerFilterOperatorOnOrBefore: i18n.t('dataGrid.headerFilterOperatorOnOrBefore'),
    headerFilterOperatorIsEmpty: i18n.t('dataGrid.headerFilterOperatorIsEmpty'),
    headerFilterOperatorIsNotEmpty: i18n.t('dataGrid.headerFilterOperatorIsNotEmpty'),
    headerFilterOperatorIsAnyOf: i18n.t('dataGrid.headerFilterOperatorIsAnyOf'),
    'headerFilterOperator=': i18n.t('dataGrid.headerFilterOperatorEqual'),
    'headerFilterOperator!=': i18n.t('dataGrid.headerFilterOperatorNotEqual'),
    'headerFilterOperator>': i18n.t('dataGrid.headerFilterOperatorGreaterThan'),
    'headerFilterOperator>=': i18n.t('dataGrid.headerFilterOperatorGreaterThanOrEqual'),
    'headerFilterOperator<': i18n.t('dataGrid.headerFilterOperatorLessThan'),
    'headerFilterOperator<=': i18n.t('dataGrid.headerFilterOperatorLessThanOrEqual'),

    // --- DataGrid
    // Column menu text
    columnMenuLabel: i18n.t("dataGrid.columnMenuLabel"),
    columnMenuShowColumns: i18n.t("dataGrid.columnMenuShowColumns"),
    columnMenuFilter: i18n.t("dataGrid.columnMenuFilter"),
    columnMenuHideColumn: i18n.t("dataGrid.columnMenuHideColumn"),
    columnMenuUnsort: i18n.t("dataGrid.columnMenuUnsort"),
    columnMenuSortAsc: i18n.t("dataGrid.columnMenuSortAsc"),
    columnMenuSortDesc: i18n.t("dataGrid.columnMenuSortDesc"),
    pinToLeft: i18n.t("dataGrid.pinToLeft"),
    pinToRight: i18n.t("dataGrid.pinToRight"),
    unpin: i18n.t("dataGrid.unpin"),
    groupingColumnHeaderName: i18n.t("dataGrid.groupingColumnHeaderName"),
    groupColumn: (name) => i18n.t("dataGrid.groupColumn", { name: name }),
    unGroupColumn: (name) => i18n.t("dataGrid.unGroupColumn", { name: name }),
  }
}

export const getResultColorCodeById = (indicators, calculationId, defaultColor = "transparent", alphaHex = "40") => {
  if (!Array.isArray(indicators)) return defaultColor;

  const indicator = indicators.find(
    (item) => Number(item.calculationId) === Number(calculationId)
  );

  let res = indicator?.resultColorCode || defaultColor;
  if (res.length === 9) {
    res = res.slice(0, -2);
  }

  res = res !== "transparent" ? lightenHex(res, 0.8) : "transparent"

  return res;
};